"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PFCard = exports.Badge = void 0;
var _stitches = require("../../../../stitches.config");
var Badge = (0, _stitches.styled)('div', {
  fontFamily: 'Neue Haas Grotesk Text Regular, Helvetica Neue helvetica, arial, sans-serif',
  position: 'absolute',
  top: -8,
  right: 5,
  fontWeight: 500,
  fontSize: 10,
  lineHeight: '16px',
  backgroundColor: 'white',
  paddingLeft: 2,
  paddingRight: 2,
  letterSpacing: '0.08em',
  variants: {
    color: {
      green: {
        color: '#11742F'
      },
      blue: {
        color: '#0077B3'
      }
    }
  }
});
exports.Badge = Badge;
var PFCard = (0, _stitches.styled)('div', {
  padding: '0px 24px 0px 16px',
  boxSizing: 'border-box',
  background: '#FFFFFF',
  border: '1px solid #C8CFD4',
  borderRadius: 4,
  boxShadow: 'none',
  position: 'relative',
  variants: {
    color: {
      green: {
        borderColor: '#11742F'
      },
      blue: {
        borderColor: '#0077B3'
      },
      default: {
        color: '#C8CFD4'
      }
    },
    size: {
      mobile: {
        width: 327,
        height: 62
      },
      tablet: {},
      desktop: {
        width: 308,
        height: 62
      }
    }
  }
});
exports.PFCard = PFCard;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');